import CertificationDTO from "../dto/CertificationDTO";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Certification from "../models/Certification";

class CertificationService extends GenericCrudService<Certification> {
  apply(badgeExternalId: string): Promise<ApiResponse<CertificationDTO>> {
    return HttpClient.post(`${this.basePath}/badges/${badgeExternalId}/start-certification`, {});
  }

  findFiltered(
    page: number,
    pageSize: number,
    badgeExternalId: string,
    search: string,
    status: string,
    level: string
  ): Promise<ApiResponseV2<PagedResult<Certification>>> {
    return HttpClientV2.get(
      `${this.basePath}/filtered?page=${page}&pageSize=${pageSize}&badgeExternalId=${badgeExternalId}&search=${search}&status=${status}&level=${level}`
    );
  }

  createCertification(certification: Certification): Promise<ApiResponse<string>> {
    return HttpClient.post(`${this.basePath}/create`, certification);
  }

  changeStatus(certificationExternalId: string, status: string): Promise<ApiResponse<Certification>> {
    return HttpClient.put(`${this.basePath}/status?certificationId=${certificationExternalId}&status=${status}`, true);
  }
}

export default new CertificationService("certifications");
